export const PaymentFailedStep: React.FC = () => {
  return (
    <div className="row">
      <p>Unfortunately there was a problem when taking your payment. Your payment has not been processed.</p>
    </div>
  );
};
